export const TYPEAHEAD_DELAY = 250;

export const LOAD_ALL_OPTION = '__TA_LOAD_MORE__';
